<style>
.bg-primary {
  background-color: #1a3665 !important;
}
</style>
<template>
  <div class="card">
    <div
      class="card-header bg-primary font-weight-bold text-white"
      style="display: flex; align-items: center;"
    >
      Data Peserta
      <Button
        class="btn btn-md btn-dark px-4 py-2 ml-auto text-white"
        @click="$router.go(-1)"
      >Kembali</Button>
    </div>
    <div class="card-header bg-white text-muted h4">Upload Absensi</div>
    <div class="card-body">
      <!-- Form RPL RNA -->
      <div class="card border-0 shadow p-2">
        <div class="card-header bg-white text-muted h4">RPL RNA</div>
        <div class="card-body">
          <form>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 1
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 2
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 3
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- End Form RPL RNA -->
      <!-- Form RPL PPAK -->
      <div class="card border-0 shadow p-2">
        <div class="card-header bg-white text-muted h4">RPL PPAK</div>
        <div class="card-body">
          <form>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 1
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 2
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 3
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- End Form RPL PPAK -->
      <!-- Form RPL BPK -->
      <div class="card border-0 shadow p-2">
        <div class="card-header bg-white text-muted h4">RPL BPK</div>
        <div class="card-body">
          <form>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 1
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 2
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 3
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- End Form RPL BPK -->
      <!-- Form CPAI Konversi -->
      <div class="card border-0 shadow p-2">
        <div class="card-header bg-white text-muted h4">RPL CPAI - Konversi</div>
        <div class="card-body">
          <form>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 1
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 2
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 3
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- End Form CPAI Konversi -->
      <!-- Form CPAI Non-Konversi -->
      <div class="card border-0 shadow p-2">
        <div class="card-header bg-white text-muted h4">RPL CPAI Non - Konversi</div>
        <div class="card-body">
          <form>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 1
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 2
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
              <div class="form-group col-md-4">
                <label for="kode" class="font-weight-bold">
                  Sesi 3
                  <small class="text-info">
                    <a href>(Lihat File)</a>
                  </small>
                </label>
                <div class="custom-file text-truncate">
                  <input
                    type="file"
                    class="custom-file-input"
                    id="validatedCustomFile"
                    @change="fileUpload"
                  />
                  <label class="custom-file-label" for="validatedCustomFile" data-browse="Unggah">{{ fileName }}.</label>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <!-- End Form CPAI Non-Konversi -->      
    </div>
    <div class="card-footer bg-white border-0 ml-auto mb-3 mr-3">      
      <router-link to="/sertifikasi/jadwal-tc/rpl-sesi-satu">
        <Button class="btn btn-md btn-success px-4 py-2" type="submit" color="success">Simpan</Button>
      </router-link>
    </div>
  </div>
</template>
<script>
export default {};
</script>